const documentsTypes = {
  file: 'file',
  link: 'link',
  video: 'video'
}

function slide (y, n) {
  return {
    title: '',
    key: `slide-${n}`,
    src: `${y}/${n}.jpg`
  }
}

function comSubtext (text, sub) {
  return `
<div>
  <span style='float: left;'>✔ ️</span>
  <p style='margin-left: 1.6rem;'>
    <strong>${text}</strong><br>
    ${sub}
  </p>
</div>`
}

export default {
  showFutureMissionDay: false,
  showProgramAndDownloads: true,
  tab: {
    key: 'c2026',
    title: '2026'
  },
  main: {
    title: `8<sup>ième</sup> Journée de la Mission Nationale SPIADI`,
    subtitle: 'Prévention des infections associées aux dispositifs invasifs : cap sur l’avenir !'
  },
  texts: [
    {
      title: 'Le 13 Octobre 2026',
      key: 'date',
      subtitle: 'de 8h à 17h',
      icon: 'event',
      text: ``
    },
    {
      title: 'Palais des congrès de Tours',
      key: 'address',
      subtitle: `
<a href="https://osm.org/go/0AU_vBkmg-?way=284415992"
   target="_blank">
  26 Boulevard Heurteloup, 37000 Tours
</a>`,
      text: 'En plein centre ville de Tours, à 100m de la gare.',
      icon: 'map'
    },
    {
      title: 'Certification Qualiopi',
      key: 'qualiopi',
      image: 'missionday/qualiopi.jpg',
      text: ''
    }
  ],

  program: [
    {
      time: '8h00',
      texts: ['Accueil des participants, émargement'],
      subtexts: [`Café d'accueil, visite des stands et installation des posters`],
      type: 'std',
      key: 'welcome'
    },
    {
      time: '8h45',
      texts: [`Ouverture de la 8<sup>ième</sup> journée de la mission nationale
       SPIADI`],
      subtexts: [
        `Dr Rémi LEFRANÇOIS, Agence Santé publique France, Saint Maurice`,
        `<br>Dr Nathalie VAN DER MEE-MARQUET, SPIADI, CPias Centre Val de Loire, CHRU Tours`,
        `<br>Pr Jean-Christophe LUCET, Président de séance, APHP CHU Bichat, Paris`
      ],
      type: 'alt',
      key: 'opening'
    },
    {
      time: '9h00',
      texts: [
        `Le risque infectieux associé aux dispositifs invasifs :
        perspectives pour les 10-20 années à venir`
      ],
      subtexts: [`Dr Gabriel BIRGAND, Praticien responsable du CPias PDL, CHU Nantes`],
      type: 'std',
      key: 'birgand'
    },
    {
      time: '9h40',
      texts: [
        `La prévention du risque infectieux lié aux dispositifs invasifs :
        les évolutions actuelles et à venir`
      ],
      subtexts: [`Pr Solen KERNEIS, Cheffe de service de la Prévention du risque infectieux, 
      hôpitaux Bichat – Beaujon – Bretonneau, AP-HP Paris`],
      type: 'alt',
      key: 'kerneis'
    },
    {
      time: '10h10',
      texts: [`Pause café - Visite des stands et des posters`],
      subtexts: [],
      type: 'pause',
      key: 'break'
    },
    {
      time: '11h00',
      texts: [`Résultats de l’étude DeepCath`],
      subtexts: [
        `Guillaume CHAZET, ICURESEARCH`
      ],
      type: 'std',
      key: 'deepCath'
    },
    {
      time: '11h30',
      texts: [`Surveillance des infections et observations des pratiques :
      faits marquants pour 2026 et résultats de l’étude SPY4`],
      subtexts: [
        `Dr Nathalie VAN DER MEE-MARQUET, Dr Anne-Sophie VALENTIN, M<sup>me</sup> Mathilde FARIZON, SPIADI`
      ],
      type: 'highlight',
      key: 'surv'
    },
    {
      time: '12h30',
      texts: ['Repas - Visite des stands et des posters'],
      subtexts: [],
      type: 'pause',
      key: 'lunch'
    },
    {
      time: '14h15',
      texts: [`Au cœur de la team SPIADI`],
      subtexts: [],
      type: 'highlight',
      key: 'team'
    },
    {
      time: '14h30',
      texts: [`Analyse des causes des bactériémies liées à un cathéter :
      analyse nationale des résultats de l’utilisation de l’outil BADICAUSE`],
      subtexts: [
        `Dr Nathalie VAN DER MEE-MARQUET, Dr Anne-Sophie VALENTIN, SPIADI`
      ],
      type: 'highlight',
      key: 'badiCause'
    },
    {
      time: '14h50',
      texts: [
        `Présentation des 2 derniers outils pédagogiques SPIADI`
      ],
      subtexts: [
        comSubtext(
          `Patient Partenaire Particulier : Passeport PICC pour les patients`,
          `M<sup>me</sup> Mathilde FARIZON, SPIADI`
        ),
        comSubtext(
          `Film CleanHand 4 – épisode 4, Hygiène des mains lors de la pose des CVP`,
          `M<sup>r</sup> Olivier FORT, CPias Centre Val de Loire`
        )
      ],
      type: 'highlight',
      key: 'ppp'
    },
    {
      time: '15h10',
      type: 'std',
      texts: [
        `COMMUNICATIONS SÉLECTIONNÉES : Surveillance, REX, analyses des causes, outils pour la formation<br><br>`
      ],
      key: 'commSelect',
      subtexts: [
        comSubtext(
          `De la surveillance à l’action : mise en place d’une formation par simulation 
          pour sécuriser la prise en charge des PICC et Midline`,
          `Dr Martine DELORME, CH Niort`
        ),
        comSubtext(
          `Optimisation médico-économique des pansements de CVC en hémodialyse`,
          `Dr Claire BIANCHI, CH Lens`
        ),
        comSubtext(
          `Évaluation de la pertinence du maintien des cathéters veineux périphériques 
          (CVP) dans un centre hospitalier intercommunal`,
          `Guillemette DE LA FOURNIÈRE, Hôpital Montreuil`
        ),
        comSubtext(
          `État des lieux de la gestion des cathéters veineux périphériques : 
          uniformiser et simplifier pour mieux tracer`,
          `Pauline BAZOGE, CHIC Amboise`
        ),
        comSubtext(
          `Observation des pratiques, engagement du patient`,
          `Dr Louis ALGLAVE, CH Douai`
        ),
        comSubtext(
          `Showroom PRI : une modalité innovante de formation courte évaluée au CHU de Limoges`,
          `Alicia CHANTECLAIRE, CHU Limoges`
        ),
        comSubtext(
          `Mise en place d’un réseau d’auditeurs pour les cathéters veineux périphériques : 
          une démarche de sensibilisation et d’évaluation continue des pratiques`,
          `David BOURRU, APHM Marseille`
        )
      ]
    },
    {
      time: '',
      type: 'alt',
      texts: [
        `Remise du prix SPIADI 2026 du meilleur poster et de la meilleure communication orale`
      ],
      subtexts: [],
      key: 'reward'
    },
    {
      time: '16h40',
      type: 'std',
      texts: [
        `Table ronde et synthèse, vie du réseau, perspectives pour 2027`
      ],
      subtexts: [],
      key: 'outlook'
    },
    {
      time: '17h00',
      texts: [`Clôture de la journée`],
      subtexts: [],
      type: 'alt',
      key: 'end'
    }
  ],

  files: [
    {
      title: `Bulletin d'inscription`,
      key: 'registration',
      icon: 'clipboard',
      type: 'success',
      text: 'À retourner avant le 2 Octobre 2026',
      link: `documents/Mission Day/2026/SPIADI2026 - Journée Nationale - Bulletin d'inscription.pdf`,
      description: `SPIADI2026 - Journée Nationale - Bulletin d'inscription.pdf`
    },
    {
      title: `Appel à communication`,
      key: 'speaker',
      icon: 'speaker',
      type: 'primary',
      text: 'À retourner avant le 31 Juillet 2026',
      link: `documents/Mission Day/2026/SPIADI2026 - Journée Nationale - Appel à communication.pdf`,
      description: 'SPIADI2026 - Journée Nationale - Appel à communication.pdf'
    },
    {
      title: `Programme de la journée`,
      key: 'schedule',
      icon: 'list',
      type: 'info',
      text: 'Mise à jour le 10 Septembre 2026',
      link: `documents/Mission Day/2026/SPIADI2026 - Journée Nationale - Programme.pdf`,
      description: 'SPIADI2026 - Journée Nationale - Programme.pdf'
    }
  ],
  congresses: [
    {
      key: 'c2026',
      year: '2026',
      title: `Prévention des infections associées aux dispositifs invasifs : 
              cap sur l’avenir !`,
      slides: [
        slide('2026', '01'),
        slide('2026', '02'),
        slide('2026', '03'),
        slide('2026', '04'),
        slide('2026', '05')
      ],
      unavailableFilesAlert: true,
      speeches: [
        {
          texts: [
            `Le risque infectieux associé aux dispositifs invasifs : perspectives pour les 10-20 années à venir`
          ],
          subtexts: [
            `Dr Gabriel BIRGAND`,
            `Praticien responsable du CPias Pays de la Loire, CHU Nantes`
          ],
          type: 'std',
          src: '2026/birgand.jpg',
          target: {
            type: documentsTypes.link,
            item: 'https://l.spiadi.fr/jn2026-birgand'
          },
          key: 'futuresHorizon',
          description: `SPIADI2026 - Dr BIRGAND - Le risque infectieux associé aux dispositifs invasifs : perspectives pour les 10-20 années à venir.pdf`
        },

        {
          texts: [
            `Prévention du risque infectieux lié aux dispositifs invasifs : les évolutions actuelles et à venir`
          ],
          subtexts: [
            `Pr Solen KERNEIS`,
            `Cheffe de service de la Prévention du risque infectieux, hôpitaux Bichat – Beaujon – Bretonneau, AP-HP Paris`
          ],
          type: 'alt',
          src: '2026/kerneis.jpg',
          target: {
            type: documentsTypes.link,
            item: 'https://l.spiadi.fr/jn2026-kerneis'
          },
          key: 'invasiveDevices',
          description: `SPIADI2026 - Pr KERNEIS - La prévention du risque infectieux lié aux dispositifs invasifs : les évolutions actuelles et à venir.pdf`
        },

        {
          texts: [`Résultats de l’étude DeepCath`],
          subtexts: [`Guillaume CHAZET`, `ICURESEARCH`],
          type: 'std',
          key: 'deepcath',
          src: '2026/chazet.jpg',
          target: {
            type: documentsTypes.link,
            item: 'https://l.spiadi.fr/jn2026-chazet'
          },
          description: `SPIADI2026 - M. CHAZET - Résultats de l’étude DeepCath.pdf`
        },

        {
          texts: [
            `Surveillance des infections et observations des pratiques : faits marquants pour 2026`
          ],
          subtexts: [
            `Dr Nathalie VAN DER MEE-MARQUET, Dr Anne-Sophie VALENTIN, M<sup>me</sup> Mathilde FARIZON`,
            `CPias Centre Val de Loire, SPIADI, CHRU Tours`
          ],
          type: 'alt',
          key: 'spiadi',
          src: '2026/van-der-mee.jpg',
          target: {
            type: documentsTypes.file,
            item: null
          },
          hover: `Diaporama à venir`,
          disabled: true,
          description: `SPIADI2026 - Dr VAN DER MEE-MARQUET, Dr VALENTIN, Mme FARIZON - Surveillance des infections et observations des pratiques - Faits marquants pour 2026.pdf`
        },

        {
          texts: [
            `Surveillance des infections et observations des pratiques : résultats de l’étude SPY4`
          ],
          subtexts: [
            `M. Dussartre`,
            `Bio-statisticien, CPias Centre Val de Loire, SPIADI, CHRU Tours`
          ],
          type: 'std',
          key: 'spy4',
          src: '2026/dussartre.jpg',
          target: {
            type: documentsTypes.file,
            item: null
          },
          hover: `Diaporama à venir`,
          disabled: true,
          description: `SPIADI2026 - M. Dussartre - Surveillance des infections et observations des pratiques - Résultats de l’étude SPY4.pdf`
        },

        {
          texts: [
            `Analyse des causes des bactériémies liées à un cathéter : analyse nationale des
résultats de l’utilisation de l’outil BADICAUSE`],
          subtexts: [
            `Dr Anne-Sophie VALENTIN, Dr Nathalie VAN DER MEE-MARQUET`,
            `CPias Centre Val de Loire, SPIADI, CHRU Tours`
          ],
          type: 'alt',
          key: 'badicause',
          src: '2026/valentin.jpg',
          target: {
            type: documentsTypes.file,
            item: null
          },
          hover: `Diaporama à venir`,
          disabled: true,
          description: `SPIADI2026 - Dr VAN DER MEE-MARQUET, Dr VALENTIN - Analyse des causes des bactériémies liées à un cathéter : analyse nationale des résultats de l’utilisation de l’outil BADICAUSE`
        },

        {
          texts: [
            `Outil pédagogique Patient Partenaire Particulier : passeport PICC pour les patients`
          ],
          subtexts: [
            `M<sup>me</sup> Mathilde FARIZON`,
            `CPias Centre Val de Loire, SPIADI, CHRU Tours`
          ],
          type: 'std',
          key: 'ppp',
          src: '2026/farizon.jpg',
          target: {
            type: documentsTypes.file,
            item: null
          },
          hover: `Diaporama à venir`,
          disabled: true,
          description: `SPIADI2026 - Mme FARIZON - Patient Partenaire Particulier : Passeport PICC pour les patients.pdf`
        },

        {
          texts: [
            `Outil pédagogique film CleanHand 4 – épisode 4 : hygiène des mains lors de la pose des CVP`
          ],
          subtexts: [
            `M. Olivier FORT, M<sup>me</sup> Mathilde FARIZON`,
            `CPias Centre Val de Loire, SPIADI, CHRU Tours`
          ],
          type: 'alt',
          key: 'cleanHand4',
          src: '2026/fort-farizon.jpg',
          target: {
            type: documentsTypes.file,
            item: null
          },
          hover: `Diaporama à venir`,
          disabled: true,
          description: `SPIADI2026 - M. FORT, Mme FARIZON - Film CleanHand 4, épisode 4 : Hygiène des mains lors de la pose des CVP.pdf`
        }
      ],

      communications: [
        {
          key: 'piccMidTraining',
          type: 'std',
          texts: [
            `De la surveillance à l’action : mise en place d’une formation par simulation pour sécuriser la prise en charge des PICC et Midline`
          ],
          subtexts: [
            `Dr Martine DELORME, CH Niort `
          ],
          target: {
            type: documentsTypes.file,
            item: null
          },
          hover: `En attente de l'autorisation de l'auteur`,
          disabled: true,
          description: 'SPIADI2026 - Dr DELORME - De la surveillance à l’action : mise en place d’une formation par simulation pour sécuriser la prise en charge des PICC et Midline.pdf'
        },

        {
          key: 'cvcDia',
          type: 'alt',
          texts: [
            `Optimisation médico-économique des pansements de CVC en hémodialyse`
          ],
          subtexts: [
            `Dr Claire BIANCHI, CH Lens`
          ],
          target: {
            type: documentsTypes.file,
            item: null
          },
          hover: `En attente de l'autorisation de l'auteur`,
          disabled: true,
          description: `SPIADI2026 - Dr BIANCHI- Optimisation médico-économique des pansements de CVC en hémodialyse.pdf`
        },

        {
          key: 'cvpMaintain',
          type: 'std',
          texts: [
            `Évaluation de la pertinence du maintien des cathéters veineux périphériques (CVP) dans un centre hospitalier intercommunal`
          ],
          subtexts: [
            `Guillemette DE LA FOURNIÈRE, Hôpital Montreuil `
          ],
          target: {
            type: documentsTypes.file,
            item: null
          },
          hover: `En attente de l'autorisation de l'auteur`,
          disabled: true,
          description: `SPIADI2026 - Mme DE LA FOURNIÈRE - Évaluation de la pertinence du maintien des cathéters veineux périphériques (CVP) dans un centre hospitalier intercommunal.pdf`
        },

        {
          key: 'cvpManagement',
          type: 'alt',
          texts: [
            `État des lieux de la gestion des cathéters veineux périphériques : uniformiser et simplifier pour mieux tracer`
          ],
          subtexts: [
            `Pauline BAZOGE, CHIC Amboise`
          ],
          target: {
            type: documentsTypes.file,
            item: null
          },
          hover: `En attente de l'autorisation de l'auteur`,
          disabled: true,
          description: `SPIADI2026 - Mme BAZOGE - État des lieux de la gestion des cathéters veineux périphériques : uniformiser et simplifier pour mieux tracer.pdf`
        },

        {
          key: 'obsPatient',
          type: 'std',
          texts: [
            `Observation des pratiques, engagement du patient`
          ],
          subtexts: [
            `Dr Louis ALGLAVE, CH Douai`
          ],
          target: {
            type: documentsTypes.file,
            item: null
          },
          hover: `En attente de l'autorisation de l'auteur`,
          disabled: true,
          description: `SPIADI2026 - Dr ALGLAVE - Observation des pratiques, engagement du patient.pdf`
        },

        {
          key: 'cvpManagement',
          type: 'alt',
          texts: [
            `État des lieux de la gestion des cathéters veineux périphériques : uniformiser et simplifier pour mieux tracer`
          ],
          subtexts: [
            `Pauline BAZOGE, CHIC Amboise`
          ],
          target: {
            type: documentsTypes.file,
            item: null
          },
          hover: `En attente de l'autorisation de l'auteur`,
          disabled: true,
          description: `SPIADI2026 - Mme BAZOGE - État des lieux de la gestion des cathéters veineux périphériques : uniformiser et simplifier pour mieux tracer.pdf`
        },

        {
          key: 'showroomPRI',
          type: 'std',
          texts: [
            `Showroom PRI : une modalité innovante de formation courte évaluée au CHU de Limoges`
          ],
          subtexts: [
            `Alicia CHANTECLAIRE, CHU Limoges`
          ],
          target: {
            type: documentsTypes.file,
            item: null
          },
          hover: `En attente de l'autorisation de l'auteur`,
          disabled: true,
          description: `SPIADI2026 - Mme CHANTECLAIRE - Auditer, simuler, former : un trio gagnant pour les CVP (Cathéters Veineux Périphériques).pdf`
        },

        {
          key: 'cvpAuditNetwork',
          type: 'alt',
          texts: [
            `Mise en place d’un réseau d’auditeurs pour les cathéters veineux périphériques : une démarche de sensibilisation et d’évaluation continue des pratiques`
          ],
          subtexts: [
            `David BOURRU, APHM Marseille`
          ],
          disabled: true,
          hover: `En attente de l'autorisation de l'auteur`,
          description: `SPIADI2026 - M. BOURRU - Mise en place d’un réseau d’auditeurs pour les cathéters veineux périphériques : une démarche de sensibilisation et d’évaluation continue des pratiques.pdf`
        }
      ]
    },
    {
      key: 'c2025',
      year: '2025',
      title: `Les innovations pour bouger les lignes dans le champ 
              de la prévention des infections liées à un cathéter`,
      slides: [
        slide('2025', '01'),
        slide('2025', '02'),
        slide('2025', '03'),
        slide('2025', '04'),
        slide('2025', '05')
      ],
      speeches: [
        {
          texts: [
            `Utilisation des pansements imprégnés d’antiseptiques et 
             prévention des infections liées à un cathéter veineux périphérique court`],
          subtexts: [`Pr Olivier MIMOZ`, `CHU Poitiers`],
          type: 'std',
          src: '2025/mimoz.jpg',
          alt: '2025/mimoz-draw.jpg',
          target: {
            type: documentsTypes.file,
            item: '2025/mimoz.pdf'
          },
          key: 'antisepticBandageAndCVP',
          description: `SPIADI2025 - Pr MIMOZ - Utilisation des pansements imprégnés d’antiseptiques et prévention des infections liées à un cathéter veineux périphérique court.pdf`
        },

        {
          texts: [
            `Expérience de l’implantation du dispositif multiligne NEO dans un service de réanimation néonatale :`,
            `Évaluation de l’impact clinique et perspectives`
          ],
          subtexts: [
            `Pr Jean-Charles PICAUD`,
            `Service de réanimation néonatale, Hôpital de la Croix Rousse, Hospices Civils de Lyon`
          ],
          type: 'alt',
          key: 'clinicalImpactNEO',
          src: '2025/picaud.jpg',
          alt: '2025/picaud-draw.jpg',
          target: {
            type: documentsTypes.file,
            item: '2025/picaud.pdf'
          },
          description: `SPIADI2025 - Pr PICAUD - Expérience de l’implantation du dispositif multiligne NEO dans un service de réanimation néonatale : Évaluation de l’impact clinique et perspectives.pdf`
        },

        {
          texts: [
            `Expérience de l’implantation du dispositif multiligne NEO dans un service de réanimation néonatale :`,
            `Processus de formation des professionnels`
          ],
          subtexts: [
            `Dr Stéphane HAYS, M<sup>me</sup> Violaine SUCHAIL-DRUTEL`,
            `Service de réanimation et médecine néonatale & pédiatrie et maternité, Hôpital de la Croix Rousse, Hospices Civils de Lyon`
          ],
          type: 'std',
          key: 'formationProcessNEO',
          src: '2025/hays-suchail.jpg',
          alt: '2025/hays-suchail-draw.jpg',
          target: {
            type: documentsTypes.file,
            item: '2025/hays.pdf'
          },
          description: `SPIADI2025 - Dr HAYS et Mme SUCHAIL-DRUTEL - Expérience de l’implantation du dispositif multiligne NEO dans un service de réanimation néonatale : Processus de formation des professionnels.pdf`
        },

        {
          texts: [`Les enjeux de l’utilisation des PICC-PORT aujourd’hui`],
          subtexts: [
            `M. Éric RODRIGUEZ`,
            `Unité d’Accès vasculaire, Centre Léon Bérard, Lyon`
          ],
          type: 'alt',
          key: 'PICC-PORT',
          src: '2025/rodriguez.jpg',
          alt: '2025/rodriguez-draw.jpg',
          target: {
            type: documentsTypes.file,
            item: '2025/rodriguez.pdf'
          },
          description: `SPIADI2025 - M. RODRIGUEZ - Les enjeux de l’utilisation des PICC-PORT aujourd’hui.pdf`
        },

        {
          texts: [`Surveillance des infections et observations des pratiques :`,
            `Faits marquants pour 2025, focus rinçage pulsé`],
          subtexts: [
            `M<sup>me</sup> Mathilde FARIZON, Dr Anne-Sophie VALENTIN, Dr Nathalie VAN DER MEE-MARQUET`,
            `CPias Centre Val de Loire, CHRU Tours`
          ],
          type: 'std',
          key: 'spiadi',
          description: `SPIADI2025 - Mme FARIZON, Dr VALENTIN et Dr VAN DER MEE-MARQUET - Surveillance des infections et observations des pratiques - Faits marquants pour 2025, focus rinçage pulsé.pdf`,
          src: '2025/farizon.jpg',
          alt: '2025/farizon-draw.jpg',
          target: {
            type: documentsTypes.file,
            item: '2025/van-der-mee-valentin.pdf'
          }
        },

        {
          texts: [`Résultats des études TOP CVP et « pansements imprégnés » en réanimation`],
          subtexts: [
            `M. Maris DUSSARTRE, Dr Nathalie VAN DER MEE-MARQUET`,
            `CPias Centre Val de Loire, CHRU Tours`
          ],
          type: 'alt',
          key: 'topCvp',
          description: `SPIADI2025 - Mr DUSSARTRE et Dr VAN DER MEE-MARQUET - Résultats des études TOP CVP et « pansements imprégnés » en réanimation.pdf`,
          src: '2025/maris.jpg',
          alt: '2025/maris-draw.jpg',
          target: {
            type: documentsTypes.file,
            item: '2025/dussartre.pdf'
          }
        },

        {
          texts: [`Résumé en images de la matinée`],
          subtexts: [
            `M. Erik TARTRAIS`
          ],
          type: 'std',
          key: 'humorous',
          description: `SPIADI2025 - Mr TARTRAIS - Résumé humoristique en images de la matinée.pdf`,
          src: '2025/tartrais.jpg',
          target: {
            type: documentsTypes.file,
            item: '2025/tartrais.pdf'
          }
        },

        {
          texts: [`Making-of de l’évolution d’OBSERVA4`],
          subtexts: [
            `Réalisé par M. Olivier Fort et toute l’équipe SPIADI`,
            `CPias Centre Val de Loire, CHRU de Tours`
          ],
          type: 'alt',
          key: 'makingOfO4',
          description: ``,
          src: '2025/observa4.jpg',
          alt: '2025/observa4-draw.jpg',
          hover: 'Voir la vidéo',
          display: {
            type: documentsTypes.video,
            source: {
              type: 'bactADI',
              link: 'https://l.spiadi.fr/les-coulisses-dobserva4'
            }
          }
        },

        {
          texts: [
            `RETEX «Capuchons imprégnés d'alcool isopropylique à 70% pour
              prévention des infections endoluminales liées aux cathéters veineux centraux»`
          ],
          subtexts: [
            `Dr Amine SI ALI`,
            `Unité de Contrôle & Prévention des Infections (CPI), CHI Créteil`
          ],
          type: 'std',
          key: 'retex',
          description: `SPIADI2025 - Dr SI ALI - RETEX Capuchons imprégnés d'alcool isopropylique à 70% pour prévention des infections endoluminales liées aux cathéters veineux centraux.pdf`,
          src: '2025/si-ali.jpg',
          target: {
            type: documentsTypes.file,
            item: '2025/siAli.pdf'
          }
        },

        {
          texts: [ `DEEPVALV` ],
          subtexts: [
            `M<sup>me</sup> Céline POULAIN`,
            `CPias Pays de la Loire`
          ],
          type: 'alt',
          key: 'deepvalv',
          description: `SPIADI2025 - Mme POULAIN - deepvalv.pdf`,
          src: '2025/poulain.jpg',
          alt: '2025/deepvalv-draw.jpg',
          target: {
            type: documentsTypes.file,
            item: '2025/poulain.pdf'
          }
        },

        {
          texts: [
            `Patient Partenaire Particulier : les premiers résultats`
          ],
          subtexts: [
            `M<sup>me</sup> Mathilde FARIZON, M<sup>me</sup> Celine Vilsans`,
            `CPias Centre Val de Loire, CHRU de Tours`
          ],
          type: 'std',
          key: 'ppp',
          description: `SPIADI2025 - Dr VALENTIN - Patient Partenaire Particulier - les premiers résultats.pdf`,
          src: '2025/farizon-vilsans.jpg',
          target: {
            type: documentsTypes.file,
            item: '2025/farizon-vilsans.pdf'
          }
        },

        {
          texts: [
            `Success SPIADI : les premiers résultats`
          ],
          subtexts: [
            `Dr Anne-Sophie VALENTIN, M<sup>me</sup> Celine Vilsans`,
            `CPias Centre Val de Loire, CHRU de Tours`
          ],
          type: 'alt',
          key: 'success',
          description: `SPIADI2025 - Dr VALENTIN - Success SPIADI - Rapport d’étape concernant les travaux du groupe.pdf`,
          src: '2025/valentin-vilsans.jpg',
          target: {
            type: documentsTypes.file,
            item: '2025/valentin-vilsans.pdf'
          }
        }
      ],

      communications: [
        {
          key: 'bandageRepairCVC',
          type: 'std',
          texts: [
            `La réfection d’un pansement à l’interface de la lutte contre les infections sur cathéters veineux centraux (CVC)`
          ],
          subtexts: [
            `Zoé Gatineau, CH Châteauroux – Le Blanc`
          ],
          hover: `En attente de l'autorisation de l'auteur`,
          disabled: true,
          description: 'SPIADI2025 - La réfection d’un pansement à l’interface de la lutte contre les infections sur cathéters veineux centraux (CVC).pdf'
        },

        {
          key: 'skinGlue',
          type: 'alt',
          texts: [
            `Colle cutanée et Midline : effets sur la fréquence des réfections de pansement et la survenue de bactériémies`
          ],
          subtexts: [
            `Dr Daphné Folliot, CH Le Mans`
          ],
          target: {
            type: documentsTypes.file,
            item: '2025/folliot.pdf'
          },
          hover: `Télécharger la présentation`,
          description: `SPIADI2025 - Colle cutanée et Midline : effets sur la fréquence des réfections de pansement et la survenue de bactériémies.pdf`
        },
        {
          key: 'healSecurity',
          type: 'std',
          texts: [
            `Sécurité des soins en hémodialyse : audit de branchements/débranchements des cathéters de dialyse et des fistules artério-veineuses`
          ],
          subtexts: [
            `Dr Dominique Trivier, CH Lens`
          ],
          target: {
            type: documentsTypes.file,
            item: '2025/trivier.pdf'
          },
          hover: `Télécharger la présentation`,
          description: `SPIADI2025 - Sécurité des soins en hémodialyse : audit de branchements/débranchements des cathéters de dialyse et des fistules artério-veineuses.pdf`
        },

        {
          key: 'PICCAtHome',
          type: 'alt',
          texts: [
            `PICC au domicile : améliorons nos pratiques !`
          ],
          subtexts: [
            `Hervé Vergnes, Hélène Bruguière, CPias Occitanie`
          ],
          target: {
            type: documentsTypes.file,
            item: '2025/vergnes.pdf'
          },
          hover: `Télécharger la présentation`,
          description: `SPIADI2025 - PICC au domicile : améliorons nos pratiques.pdf`
        },

        {
          key: 'auditAndTraining',
          type: 'std',
          texts: [
            `Auditer, simuler, former : un trio gagnant pour les CVP (Cathéters Veineux Périphériques)`
          ],
          subtexts: [
            `Christelle Feuillerat, CHI A. Grégoire Montreuil`
          ],
          target: {
            type: documentsTypes.file,
            item: '2025/feuillerat.pdf'
          },
          hover: `Télécharger la présentation`,
          description: `SPIADI2025 - Auditer, simuler, former : un trio gagnant pour les CVP (Cathéters Veineux Périphériques).pdf`
        },

        {
          key: 'veinitisInChir',
          type: 'alt',
          texts: [
            `Maitrise du risque infectieux lié aux dispositifs invasifs : objectif de réduction de la survenue des veinites dans un service de chirurgie`
          ],
          subtexts: [
            `Marie Barois, Clinique Lille Sud - SOS Mains`
          ],
          disabled: true,
          hover: `En attente de l'autorisation de l'auteur`,
          description: `SPIADI2025 - Maitrise du risque infectieux lié aux dispositifs invasifs : objectif de réduction de la survenue des veinites dans un service de chirurgie.pdf`
        }
      ]
    },

    {
      key: 'c2024',
      year: '2024',
      title: `L'engagement du patient et la prévention des infections liées à un cathéter`,
      slides: [
        slide('2024', '01'),
        slide('2024', '03'),
        slide('2024', '02'),
        slide('2024', '05'),
        slide('2024', '07')
      ],
      speeches: [
        {
          texts: [`La surveillance et la prévention des infections liées à un cathéter : enseignements des données de surveillance, et perspectives à venir`],
          subtexts: [
            `Dr Sonja HANSEN, Institute of Hygiene and Environmental Medicine`,
            `Charité – Universitätsmedizin Berlin, Allemagne`
          ],
          type: 'std',
          src: '2024/hansen.jpg',
          disabled: true,
          key: 'surveillancePrevention',
          description: `SPIADI2024 - DR HANSEN - La surveillance et la prévention des infections liées à un cathéter : Enseignements des données de surveillance, et perspectives à venir.pdf`
        },

        {
          texts: [`L’engagement des patients au service de la prévention des infections : enseignement de l’expérience des patients`],
          subtexts: [
            `Dr Dominique POUGHEON BERTRAND`,
            `Université Sorbonne, Paris`
          ],
          type: 'alt',
          key: 'engagementPatient',
          src: '2024/pougheon.jpg',
          target: {
            type: documentsTypes.file,
            item: '2024/pougheon.pdf'
          },
          description: `SPIADI2024 - Dr POUGHEON - L’engagement des patients au service de la prévention des infections : enseignement de l’expérience des patients.pdf`
        },

        {
          texts: [
            `La surveillance des bactériémes liées à un cathéter et les observations de pratiques :`,
            `faits marquants, indicateurs nationaux et focus MIDline avec prolongateur intégré`],
          subtexts: [
            `Dr Nathalie VAN DER MEE-MARQUET et Dr Anne-Sophie VALENTIN`,
            `CPias Centre Val de Loire, CHRU Tours`
          ],
          type: 'std',
          key: 'spiadi',
          description: `SPIADI2024 - Dr VAN DER MEE et Dr VALENTIN - Faits marquants, indicateurs nationaux et focus MIDline avec prolongateur intégré.pdf`,
          src: '2024/van-der-mee-valentin.jpg',
          target: {
            type: documentsTypes.file,
            item: '2024/van-der-mee-valentin.pdf'
          }
        },

        {
          texts: [`Étude ChronoBIOline : résultats et perspectives`],
          subtexts: [
            `L’équipe SPIADI`,
            `CPias Centre Val de Loire, CHRU Tours`
          ],
          type: 'alt',
          key: 'chronoBIOline',
          description: `SPIADI2024 - L’équipe SPIADI - Étude ChronoBIOline : résultats et perspectives.pdf`,
          src: '2024/farizon-borges.jpg',
          target: {
            type: documentsTypes.file,
            item: '2024/farizon-borges.pdf'
          }
        },

        {
          texts: [
            `Solution d'accès vasculaire efficiente`
          ],
          subtexts: [
            `Dr Stéphane ILUNGA et Romain HABRZYK`,
            `Cabinet SAVE, Lille`
          ],
          type: 'std',
          key: 'organisation',
          description: `SPIADI2024 - Dr Stéphane ILUNGA et Romain HABRZYK - Solution d'accès vasculaire efficiente.pdf`,
          src: '2024/ilunga.jpg',
          target: {
            type: documentsTypes.file,
            item: '2024/ilunga.pdf'
          }
        },
        {
          texts: [`Engager le patient porteur de PICC : l'expérience du Centre Hospitalier Universitaire de Nantes`],
          subtexts: [
            `Dr Mathilde PETIT`,
            `CHU de Nantes`
          ],
          type: 'std',
          key: 'nantes',
          description: `SPIADI2024 - Dr Mathilde PETIT - Engager le patient porteur de PICC : l'expérience du Centre Hospitalier Universitaire de Nantes.pdf`,
          src: '2024/petit.jpg',
          target: {
            type: documentsTypes.file,
            item: '2024/petit.pdf'
          }
        },

        {
          texts: [`DEEPCATH : Résultats de la première phase et travaux en cours`],
          subtexts: [
            `Stéphane RUCKLY, Marwa KOUMAIHA, ICUREsearch`,
            `Lyse GALLAY, Institut de l'Intelligence Artificielle en Santé`
          ],
          type: 'alt',
          key: 'deepcath',
          description: `SPIADI2024 - Stéphane RUCKLY, Marwa KOUMAIHA - DEEPCATH : Résultats de la première phase et travaux en cours.pdf`,
          src: '2024/ruckly.jpg',
          target: {
            type: documentsTypes.file,
            item: '2024/ruckly.pdf'
          }
        },
        {
          texts: [`Le bon usage des Midlines avec prolongateur intégré : présentation de l'outil Midline Express`],
          subtexts: [
            `Mathilde FARIZON, Nathalie RÉGINAUD`,
            `CPias Centre Val de Loire, CHRU de Tours`
          ],
          type: 'alt',
          key: 'midlineExpress',
          description: `SPIADI2024 - Mathilde FARIZON, Nathalie RÉGINAUD - Présentation de l'outil Midline Express.pdf`,
          src: '2024/farizon.jpg',
          target: {
            type: documentsTypes.file,
            item: '2024/farizon.pdf'
          }
        }
      ],
      communications: [
        {
          key: 'midlines',
          type: 'std',
          texts: [
            `Surveillance des complications associées aux midlines avec prolongateur intégré`
          ],
          subtexts: [
            `Dr Daphné Folliot, CH Le Mans`
          ],
          target: {
            type: documentsTypes.file,
            item: '2024/folliot.pdf'
          },
          hover: 'Télécharger la présentation',
          description: 'SPIADI2024 - Surveillance des complications associées aux midlines avec prolongateur intégré.pdf'
        },
        {
          key: 'piccLine',
          type: 'alt',
          texts: [
            `PICC Line et supports visuels éducatifs : la parole aux patients`
          ],
          subtexts: [
            `Dr Laura Foucaut-Fruchard, AP-HP Paris`
          ],
          target: {
            type: documentsTypes.file,
            item: '2024/foucaut.pdf'
          },
          hover: 'Télécharger la présentation',
          description: `PICC Line et supports visuels éducatifs : la parole aux patients.pdf`
        },
        {
          key: 'tools',
          type: 'std',
          texts: [
            `Apport des outils SPIADI dans la prévention et le contrôle des infections en réanimation`
          ],
          subtexts: [
            `Dr Caroline Laurans, Sylvain Normandin, CH Roubaix`
          ],
          target: {
            type: documentsTypes.file,
            item: '2024/laurans.pdf'
          },
          hover: 'Télécharger la présentation',
          description: `SPIADI2024 - Apport des outils SPIADI dans la prévention et le contrôle des infections en réanimation.pdf`
        },

        {
          key: 'buttonHole',
          type: 'alt',
          texts: [
            `La Solution hydroalcoolique ou les gants pour l’auto-ponction des Button Hole ?`
          ],
          subtexts: [
            `Dr Cécile Bourgain, AURA Paris`
          ],
          target: {
            type: documentsTypes.file,
            item: '2024/bourgain.pdf'
          },
          hover: 'Télécharger la présentation',
          description: `SPIADI2024 - La Solution hydroalcoolique ou les gants pour l’auto-ponction des Button Hole ?.pdf`
        }
      ]
    },

    {
      key: 'c2023',
      year: '2023',
      title: `L'engagement du patient et la prévention des infections liées à un cathéter`,
      slides: [
        slide('2023', '05'),
        slide('2023', '02'),
        slide('2023', '03'),
        slide('2023', '04')
      ],
      speeches: [
        {
          texts: [`Les enjeux de l'engagement du patient et la prévention des infections
liées à un cathéter`],
          subtexts: [`Pr Jean Ralph ZAHAR, AP-HP Avicenne`],
          type: 'std',
          src: '2023/zahar.jpg',
          target: {
            type: documentsTypes.file,
            item: '2023/zahar.pdf'
          },
          key: 'news',
          description: `SPIADI2023 - Pr ZAHAR - Les enjeux de l'engagement du patient et la prévention des infections
liées à un cathéter.pdf`
        },

        {
          texts: [
            `L'expérience des patients hémodialysés chroniques`
          ],
          subtexts: [`Dr Abdallah GUERRAOUI, Centre de Santé CALYDIAL, Vénissieux`],
          type: 'alt',
          key: 'hempat',
          src: '2023/guerraoui.jpg',
          target: {
            type: documentsTypes.file,
            item: '2023/guerraoui.pdf'
          },
          description: `SPIADI2023 - Dr GUERRAOUI - L'expérience des patients hémodialysés choniques.pdf`
        },

        {
          texts: [`Construire la relation patient - professionnel pour les patients atteints de
pathologie infectieuse chronique`],
          subtexts: [`Dr Guillaume GRAS, Service maladies infectieuses, CHRU de Tours`],
          type: 'std',
          key: 'relation',
          description: `SPIADI2023 - Dr GRAS - Construire la relation patient - professionnel pour les patients atteints de
pathologie infectieuse chronique.pdf`,
          src: '2023/gras.jpg',
          target: {
            type: documentsTypes.file,
            item: '2023/gras.pdf'
          }
        },

        {
          texts: [`L'attente du patient en matière de prévention des infections liées à un cathéter`],
          subtexts: [`M<sup>me</sup> Chantal CATEAU, Présidente de l'association Le Lien, Paris`],
          type: 'alt',
          key: 'attpat',
          description: `SPIADI2023 - L'attente du patient en matière de prévention des infections liées à un cathéter.pdf`,
          src: '2023/cateau.jpg',
          target: {
            type: documentsTypes.file,
            item: '2023/cateau.pdf'
          }
        },

        {
          texts: [`Surveillance des infections : les principaux
enseignements des campagnes menées depuis 2019 et les faits marquants pour 2023`],
          subtexts: [
            `Dr Nathalie VAN DER MEE-MARQUET, CPias Centre Val de Loire, CHRU de Tours`
          ],
          type: 'std',
          key: 'spiadi',
          description: `SPIADI2023 - Surveillance des infections : les principaux
enseignements des campagnes menées depuis 2019 et les faits marquants pour 2023.pdf`,
          src: '2023/surveillance.jpg',
          target: {
            type: documentsTypes.file,
            item: '2023/surveillance.pdf'
          }
        },
        {
          texts: [`Observations des pratiques : les principaux
enseignements des campagnes menées depuis 2019 et les faits marquants pour 2023`],
          subtexts: [
            `Dr Anne-Sophie VALENTIN, CPias Centre Val de Loire, CHRU de Tours`
          ],
          type: 'std',
          key: 'obs4',
          description: `SPIADI2023 - Observations des pratiques : les principaux
enseignements des campagnes menées depuis 2019 et les faits marquants pour 2023.pdf`,
          src: '2023/observation.jpg',
          target: {
            type: documentsTypes.file,
            item: '2023/observation.pdf'
          }
        },

        {
          texts: [`CleanHand Prox : résultats de l'étude`],
          subtexts: [
            `Sandra DOS SANTOS BORGES, Mathilde FARIZON, Dr Anne-Sophie VALENTIN,
CPias Centre Val de Loire, CHRU de Tours`
          ],
          type: 'alt',
          key: 'chp',
          description: `SPIADI2023 - CleanHand Prox : résultats de l'étude.pdf`,
          src: '2023/chp.jpg',
          target: {
            type: documentsTypes.file,
            item: '2023/chp.pdf'
          }
        },

        {
          texts: [`Deepcath : point sur l'étude en cours`],
          subtexts: [`M. Stéphane RUCKLY, ICUREsearch`],
          type: 'std',
          key: 'deepcath',
          description: `SPIADI2023 - Deepcath : point sur l'étude en cours.pdf`,
          src: '2023/deepcath.jpg',
          target: {
            type: documentsTypes.file,
            item: '2023/deepcath.pdf'
          }
        },

        {
          texts: [`Résultats de l'étude TROPI4 : manipulations et pansements de PICClines, MIDlines et CCI en ville`],
          subtexts: [`Dr Catherine AVRIL, M<sup>me</sup> Christine BANGUY, CPias Océan Indien, Saint Denis`],
          type: 'std',
          key: 'tropi4',
          description: `SPIADI2023 - Résultats de l'étude TROPI4 : manipulations et pansements de PICClines, MIDlines et CCI en ville.pdf`,
          src: '2023/tropi4.jpg',
          target: {
            type: documentsTypes.file,
            item: '2023/tropi4.pdf'
          }
        }
      ],
      communications: [
        {
          key: 'limoges',
          type: 'alt',
          texts: [
            `Apport de la mise en place d'un logiciel de gestion des hémocultures pour la`,
            `surveillance des infections associées aux dispositifs invasifs`
          ],
          subtexts: [
            `Dr Léa MARCO, Dr Nathalie D'HOLLANDER-PESTOURIE, CHU Limoges`
          ],
          target: {
            type: documentsTypes.file,
            item: '2023/limoges.pdf'
          },
          hover: 'Télécharger la présentation',
          description: `SPIADI2023 - Apport de la mise en place d'un logiciel de gestion des hémocultures pour la surveillance des infections associées aux dispositifs invasifs.pdf`
        },
        {
          key: 'denain',
          type: 'std',
          texts: [
            `Formation sur la prévention des infections liées aux VVP`
          ],
          subtexts: [
            `M. Bastien SALOMÉ, CH Denain`
          ],
          target: {
            type: documentsTypes.file,
            item: '2023/denain.pdf'
          },
          hover: 'Télécharger la présentation',
          description: 'SPIADI2023 - Formation sur la prévention des infections liées aux VVP.pdf'
        },
        {
          key: 'aphp',
          type: 'alt',
          texts: [
            `Évaluation de la maîtrise du risque infectieux lié aux VVP périphériques : audit
institutionnel auprès d'IDE et de patients`
          ],
          subtexts: [
            `M<sup>me</sup> Valérie SOUYRI, AP-HP Paris`
          ],
          target: {
            type: documentsTypes.file,
            item: '2023/aphp.pdf'
          },
          hover: 'Télécharger la présentation',
          description: `SPIADI2023 - Évaluation de la maîtrise du risque infectieux lié aux VVP périphériques : audit
institutionnel auprès d'IDE et de patients.pdf`
        },
        {
          key: 'roubaix',
          type: 'std',
          texts: [
            `Hémodialyse et prévention du risque infectieux : résultats d'un audit des pratiques
en 2023`
          ],
          subtexts: [
            `M<sup>me</sup> Manon CAUDRON, CH Roubaix`
          ],
          target: {
            type: documentsTypes.file,
            item: '2023/roubaix.pdf'
          },
          hover: 'Télécharger la présentation',
          description: `SPIADI2023 - Hémodialyse et prévention du risque infectieux : résultats d'un audit des pratiques
en 2023.pdf`
        },
        {
          key: 'tours',
          type: 'alt',
          texts: [
            `La visite de risque en hémodialyse : une démarche impliquant les patients pour la prévention`,
            `du risque infectieux`
          ],
          subtexts: [
            `Dr Céline LENGELLÉ, CHRU Tours`
          ],
          target: {
            type: documentsTypes.file,
            item: '2023/tours.pdf'
          },
          hover: 'Télécharger la présentation',
          description: `SPIADI2023 - La visite de risque en hémodialyse : une démarche impliquant les patients pour la prévention du risque infectieux.pdf`
        }
      ]
    },
    {
      key: 'c2022',
      year: '2022',
      slides: [
        slide('2022', '01'),
        slide('2022', '02'),
        slide('2022', '03'),
        slide('2022', '04')
      ],
      speeches: [
        {
          texts: [`Les nouveautés à venir concernant les recommandations internationales
pour la prévention des infections liées à un cathéter`],
          subtexts: [`Dr Niccolò BUETTI, Infection Control Program and WHO Collaborating
Centre on Patient Safety, Hôpital Universitaire de Genève`],
          type: 'std',
          src: '2022/buetti-news.jpg',
          key: 'buetti-news',
          target: {
            type: documentsTypes.file,
            item: '2022/buetti-news.pdf'
          },
          description: `SPIADI2022 - Dr BUETTI - Les nouveautés à venir concernant les recommandations internationales
pour la prévention des infections liées à un cathéter.pdf`
        },
        {
          texts: [
            `Deepcath : développement d'une application mobile pour détecter les signes
locaux d'infection liée au cathéter`
          ],
          subtexts: [`Équipe Deepcath, ICuresearch`],
          type: 'alt',
          src: '2022/deepcath.jpg',
          key: 'deepcath',
          target: {
            type: documentsTypes.file,
            item: '2022/deepcath.pdf'
          },
          description: `SPIADI2022 - Équipe Deepcath - Développement d'une application mobile pour
détecter les signes locaux d'infection liée au cathéter.pdf`
        },
        {
          texts: [`Le risque infectieux lié à l'utilisation de l'échoguidage pour la pose
des cathéthers centraux`],
          subtexts: [
            `Dr Niccolò BUETTI, Infection Control Program and WHO Collaborating
Centre on Patient Safety, Hôpital Universitaire de Genève`
          ],
          type: 'std',
          src: '2022/buetti-echo.jpg',
          key: 'buetti-echo',
          target: {
            type: documentsTypes.file,
            item: '2022/buetti-echo.pdf'
          },
          description: `SPIADI2022 - Le risque infectieux lié à l'utilisation de l'échoguidage pour la pose
des cathéthers centraux`
        },
        {
          texts: [
            `Résultats de l'enquête SPIADI 2022 portant sur l'utilisation de
l'échoguidage pour la pose des cathéters centraux`
          ],
          subtexts: [`Isabelle DUFLOT et Dr Anne-Sophie VALENTIN, CPias Centre Val de Loire, CHRU Tours`],
          type: 'alt',
          src: '2022/echo.jpg',
          key: 'echo',
          target: {
            type: documentsTypes.file,
            item: '2022/echo.pdf'
          },
          description: `SPIADI2022 - Résultats de l'enquête portant sur l'utilisation de l'échoguidage
pour la pose des cathéters centraux`
        },
        {
          texts: [
            `Surveillance nationale des bactériémies liées aux cathéters, évolutions 2019-2022`
          ],
          subtexts: [
            `Dr Nathalie VAN DER MEE-MARQUET, CPias Centre Val de Loire, CHRU Tours`
          ],
          type: 'std',
          src: '2022/nvdm.jpg',
          key: 'nvdm',
          target: {
            type: documentsTypes.file,
            item: '2022/nvdm.pdf'
          },
          description: `SPIADI2022 - Surveillance nationale des bactériémies liées aux cathéters, évolutions 2019-2022.pdf`
        },
        {
          texts: [`Les enjeux du retrait systématique des cathéters périphériques`],
          subtexts: [`Dr Niccolò BUETTI, Infection Control Program and WHO Collaborating
Centre on Patient Safety, Hôpital Universitaire de Genève`],
          type: 'alt',
          src: '2022/buetti-cvp.jpg',
          key: 'buetti-cvp',
          target: {
            type: documentsTypes.file,
            item: '2022/buetti-cvp.pdf'
          },
          description: `SPIADI2022 - Dr BUETTI - Les enjeux du retrait systématique des cathéters périphériques.pdf`
        },
        {
          texts: [
            `Résultats de l'enquête nationale portant sur l'appropriation des
recommandations «Prévention des infections liées aux cathéters périphériques vasculaires
et sous-cutanés»`,
            `(SF2H 2019)`
          ],
          subtexts: [`Dr Mathieu LLORENS, CHR Metz-Thionville`],
          type: 'alt',
          src: '2022/llorens.jpg',
          key: 'lorrens',
          target: {
            type: documentsTypes.file,
            item: '2022/llorens.pdf'
          },
          description: `SPIADI2022 - Dr LLORENS - Résultats de l'enquête nationale portant sur l'appropriation des
recommandations «Prévention des infections liées aux cathéters périphériques vasculaires
et sous-cutanés» (SF2H 2019).pdf`
        },
        {
          texts: [`Campagne OBSERVA4, données marquantes pour 2022`],
          subtexts: [`Dr Anne-Sophie VALENTIN, CPias Centre Val de Loire, CHRU TOURS`],
          type: 'std',
          src: '2022/anneso.jpg',
          key: 'o4',
          target: {
            type: documentsTypes.file,
            item: '2022/observa4.pdf'
          },
          description: `SPIADI2022 - Campagne OBSERVA4 - Données marquantes pour 2022.pdf`
        },
        {
          texts: [
            `CleanHand4 : Résultats de l'étude et présentation de l'outil pédagogique`
          ],
          subtexts: [`Mathilde FARIZON pour l'équipe SPIADI, CPias Centre Val de Loire, CHRU Tours`],
          type: 'alt',
          src: '2022/mathilde.jpg',
          key: 'cleanhand4',
          target: {
            type: documentsTypes.file,
            item: '2022/mathilde.pdf'
          },
          description: `SPIADI2022 - CLEANHAND4 - Résultats de l'étude et présentation de l'outil pédagogique.pdf`
        }
      ],
      communications: [
        {
          key: 'nephrocare',
          type: 'alt',
          texts: [
            `Amélioration des pratiques de ponction des fistules artérioveineuses selon la`,
            `technique de ponction en Button Hole (BH) chez le patient dialysé`
          ],
          subtexts: [
            `Isabelle LEDUC, Nephrocare Île-de-France`
          ],
          target: {
            type: documentsTypes.file,
            item: '2022/nephrocare.pdf'
          },
          hover: 'Télécharger la présentation',
          description: 'Amélioration des pratiques de ponction des fistules artérioveineuses selon la technique de ponction en Button Hole (BH) chez le patient dialysé.pdf'
        },
        {
          key: 'nancy',
          type: 'std',
          texts: [
            `NEOCAT / SPIADI : bilan de 6 années de surveillance`
          ],
          subtexts: [
            `Dr COLAS, CHRU de Nancy`
          ],
          target: {
            type: documentsTypes.file,
            item: '2022/nancy.pdf'
          },
          hover: 'Télécharger la présentation',
          description: 'NEOCAT - SPIADI : bilan de 6 années de surveillance.pdf'
        },
        {
          key: 'ght',
          type: 'alt',
          texts: [
            `Intérêt d'une surveillance spécifique active des Midlines au sein d'un GHT`
          ],
          subtexts: [
            `Dr Caroline BENET et Dr Laëtitia VAILLANT, GH Nord Essonne`
          ],
          target: {
            type: documentsTypes.file,
            item: '2022/ght.pdf'
          },
          hover: 'Télécharger la présentation',
          description: `Intérêt d'une surveillance spécifique active des Midlines au sein d'un GHT.pdf`
        },
        {
          key: 'piccmid',
          type: 'std',
          texts: [
            `5 ans d'ateliers de simulation PICCLine Midline`
          ],
          subtexts: [
            `Anne BLANCARD, Dr Lucie GERMOND, CHU Clermont-Ferrand`
          ],
          target: {
            type: documentsTypes.file,
            item: '2022/piccmid.pdf'
          },
          hover: 'Télécharger la présentation',
          description: `5 ans d'ateliers de simulation PICCLine Midline.pdf`
        },
        {
          key: 'ville',
          type: 'alt',
          texts: [
            `La prise en charge des PICC et Midlines en ville. Mesure de l'impact d'une`,
            `formation auprès des infirmiers libéraux`
          ],
          subtexts: [
            `Amélie POUZET et Dr Chloé CHANTEREAU-JANSEN, CHD Vendée, La Roche sur Yon`
          ],
          target: {
            type: documentsTypes.file,
            item: '2022/ville.pdf'
          },
          hover: 'Télécharger la présentation',
          description: `La prise en charge des PICC et Midlines en ville. Mesure de l'impact d'une formation auprès des infirmiers libéraux.pdf`
        },

        {
          key: 'patient',
          type: 'std',
          hover: `Télécharger la présentation`,
          texts: [
            `Mise en place d'une action éducative auprès des patients porteurs d'un PICCline
ou d'un Midline : étude de faisabilité`
          ],
          subtexts: [
            `Dr Séverine GALLAIS-HOFF, CH St Nazaire`
          ],
          target: {
            type: documentsTypes.file,
            item: '2022/patient.pdf'
          },
          description: `Mise en place d'une action éducative auprès des patients porteurs d'un PICCline
ou d'un Midline : étude de faisabilité`
        },

        {
          key: 'rexmid',
          type: 'alt',
          texts: [
            `Retour d'expérience sur la mise en place du MIDline à prolongateur intégré dans un Centre Hospitalier`
          ],
          subtexts: [
            `Dr Marion ROBERT, CH Douai`
          ],
          target: {
            type: documentsTypes.file,
            item: '2022/rexmid.pdf'
          },
          hover: 'Télécharger la présentation',
          description: `Retour d'expérience sur la mise en place du MIDline à prolongateur intégré dans un Centre Hospitalier.pdf`
        },

        {
          key: 'pad',
          type: 'std',
          hover: `Télécharger la présentation`,
          texts: [
            `Implantation de pansement renforcé pour cathéter périphérique (CVP)`
          ],
          subtexts: [
            `Bruno LE FAHLER, CH Argenteuil`
          ],
          target: {
            type: documentsTypes.file,
            item: '2022/pad.pdf'
          },
          description: `Implantation de pansement renforcé pour cathéter périphérique (CVP)`
        }

      ]
    },
    {
      key: 'c2021',
      year: '2021',
      slides: [
        slide('2021', '03'),
        slide('2021', '04'),
        slide('2021', '05'),
        slide('2021', '08'),
        slide('2021', '06'),
        slide('2021', '07')
      ],
      speeches: [
        {
          texts: [`Stratégie nationale de lutte contre les infections et
        l'antibiorésistance : les actualités`],
          subtexts: [`Pr Céline PULCINI, Ministère de la
        Solidarité et de la Santé, Paris`],
          type: 'std',
          src: '2021/pulcini.jpg',
          key: 'pulcini',
          target: {
            type: documentsTypes.file,
            item: '2021/pulcini.pdf'
          },
          description: `SPIADI2021 - Pr PULCINI - Stratégie nationale de lutte contre les infections et l'antibiorésistance : les actualités.pdf`
        },
        {
          texts: [
            `Mesures de prévention des infections liées aux cathéters`
          ],
          subtexts: [`Pr Jean-François TIMSIT, Hôpital Bichat APHP, Paris`],
          type: 'alt',
          src: '2021/timsit.jpg',
          key: 'timsit',
          target: {
            type: documentsTypes.file,
            item: '2021/timsit.pdf'
          },
          description: `SPIADI2021 - Pr TIMSIT - Mesures de prévention des infections liées aux cathéters.pdf`
        },
        {
          texts: [`REA-ExplAUR : résultats de l'enquête 2021`],
          subtexts: [
            `Dr Nathalie VAN DER MEE-MARQUET, Sandra DOS SANTOS BORGES, CPias Centre Val de Loire, CHRU Tours`
          ],
          type: 'std',
          src: '2021/explaur.jpg',
          key: 'explaur',
          target: {
            type: documentsTypes.file,
            item: '2021/explaur.pdf'
          },
          description: `SPIADI2021 - Résultats de l'enquête RÉA expl AUR`
        },
        {
          texts: [
            `Étude exploratoire de l'impact de 3 variables organisationnelles sur l'incidence des bactériémies associées aux cathéters centraux, service de réanimation adulte`
          ],
          subtexts: [`Pr Philippe BERTHELOT, Unité de gestion du risque infectieux, CHU Saint-Etienne`],
          type: 'alt',
          src: '2021/berthelot.jpg',
          key: 'berthelot',
          target: {
            type: documentsTypes.file,
            item: '2021/berthelot.pdf'
          },
          description: `SPIADI2021 - Pr BERTHELOT - Étude exploratoire de l'impact de 3 variables organisationnelles sur l'incidence des bactériémies associées aux cathéters centraux service de réanimation adulte.pdf`
        },
        {
          texts: [`Les données SPIADI pour la recherche`],
          subtexts: [`Rémi GIMENES, CPias Centre Val de Loire, CHRU TOURS`],
          type: 'std',
          src: '2021/remi.jpg',
          key: 'remi',
          target: {
            type: documentsTypes.file,
            item: '2021/remi.pdf'
          },
          description: `SPIADI2021 - Les données SPIADI pour la recherche.pdf`
        },
        {
          texts: [`Résultats de la surveillance 2021`],
          subtexts: [`Équipe SPIADI, CPias Centre Val de Loire, CHRU Tours`],
          type: 'alt',
          src: '2021/surv.jpg',
          key: 'surv',
          target: {
            type: documentsTypes.file,
            item: '2021/surv.pdf'
          },
          description: `SPIADI2021 - Résultats de la surveillance.pdf`
        },
        {
          texts: [`Résultats de la campagne OBSERVA4 2021`],
          subtexts: [`Équipe SPIADI, CPias Centre Val de Loire, CHRU Tours`],
          type: 'std',
          src: '2021/observa4.jpg',
          key: 'o4',
          target: {
            type: documentsTypes.file,
            item: '2021/observa4.pdf'
          },
          description: `SPIADI2021 - Résultats de la campagne OBSERVA4.pdf`
        },
        {
          texts: [
            `Infections liées aux cathéters en Oncologie et Hématologie`
          ],
          subtexts: [`Dr Pierre Berger, Institut Paoli-Calmettes, Marseille`],
          type: 'alt',
          src: '2021/berger.jpg',
          key: 'berger',
          target: {
            type: documentsTypes.file,
            item: '2021/berger.pdf'
          },
          description: `SPIADI2021 - Dr BERGER - Infections liées aux cathéters en Oncologie et Hématologie.pdf`
        },
        {
          texts: [
            `Analyse des résultats portant sur les bactériémies associées aux PICClines`,
            `Expérience du CHRU de Caen`],
          subtexts: [`Pr Olivier JOIN-LAMBERT, Dr Claire LESTEVEN, CHRU de Caen`],
          type: 'std',
          src: '2021/caen.jpg',
          key: 'caen',
          target: {
            type: documentsTypes.file,
            item: '2021/caen.pdf'
          },
          description: `SPIADI2021 - Pr JOIN-LAMBERT Dr LESTEVEN - Analyse des résultats portant sur les bactériémies associées aux
PICClines.pdf`
        }
      ],
      communications: [
        {
          key: 'conrath',
          type: 'alt',
          texts: [
            `Évaluation des pratiques concernant les nouvelles recommandations sur les antiseptiques`,
            `Cas de l'utilisation des antiseptiques de type alcoolique chez l'adulte sur peau saine`
          ],
          subtexts: [
            `Élodie CONRATH, CHRU de Nancy`
          ]
        },
        {
          key: 'lecomte',
          type: 'std',
          texts: [
            `Bon usage du gel d'échographie et maîtrise du risque infectieux lié à la pose de dispositifs intra-vasculaires`
          ],
          subtexts: [
            `Soizic LECOMTE, CHRU de Tours`
          ]
        },
        {
          key: 'regueme',
          type: 'alt',
          texts: [
            `Évaluation de la pertinence de maintien des CVP au CH de Roubaix`
          ],
          subtexts: [
            `Alexandre REGUEME, CPias Hauts de France`
          ]
        },
        {
          key: 'vergnes',
          type: 'std',
          texts: [
            `Prise en charge d'un patient porteur de PICC en HAD : enquête régionale, résultats et analyse`
          ],
          subtexts: [
            `Hervé VERGNES, CPias Occitanie`
          ]
        },
        {
          key: 'poulain',
          type: 'alt',
          texts: [
            `Présentation d'un outil pédagogique pour l'amélioration de la gestion des PICCline et MIDline à domicile`
          ],
          subtexts: [
            `Céline POULAIN, CPias Pays de Loire`
          ]
        },
        {
          key: 'lily',
          type: 'std',
          src: 'missionday/2021/lily.jpg',
          target: {
            type: documentsTypes.link,
            item: 'https://www.spiadi.fr/tools?tab=1'
          },
          hover: `Accéder à l'outil`,
          texts: [
            `Outil pédagogique pour la prévention des infections liées aux cathéters : Lily II - VALV'FRICTION`
          ],
          subtexts: [`Équipe SPIADI, CPias Centre Val de Loire, CHRU Tours`]
        }
      ]
    },
    {
      key: 'c2020',
      year: '2020',
      slides: [
        slide('2020', '03'),
        slide('2020', '05'),
        slide('2020', '06'),
        slide('2020', '07'),
        slide('2020', '09'),
        slide('2020', '11')
      ],
      speeches: [
        {
          texts: [
            `Staphylococcus aureus et dispositifs invasifs : des particularités
microbiologiques à la réalité des infections bactériémiques`
          ],
          subtexts: [
            `Pr Frédéric LAURENT, CNR des Staphylocoques, Institut des Agents
Infectieux, Hospices Civiles de Lyon`
          ],
          type: 'std',
          src: '2020/laurent.jpg',
          key: 'laurent',
          target: {
            type: documentsTypes.file,
            item: '2020/laurent.pdf'
          },
          description: `SPIADI 2020 - Pr LAURENT - S. aureus et dispositifs invasifs.pdf`
        },
        {
          texts: [
            `Staphylococcus aureus et dispositif invasif: la réalité des
bactériémies`
          ],
          subtexts: [
            `Dr Amandine GAGNEUX-BRUNON, Service d'infectiologie, CHU
Saint-Etienne`
          ],
          type: 'alt',
          src: '2020/gagneux brunon.jpg',
          key: 'gagneux',
          target: {
            type: documentsTypes.file,
            item: '2020/gagneux brunon.pdf'
          },
          description: `SPIADI 2020 - Dr GAGNEUX-BRUNON - S. aureus et dispositifs invasifs.pdf`
        },
        {
          texts: [`Premiers résultats de la surveillance nationale SPIADI 2020`],
          subtexts: [
            `Dr Nathalie VAN DER MEE-MARQUET, SPIADI, CPias Centre val de Loire,
CHU Tours`
          ],
          type: 'std',
          src: '2020/spiadi.jpg',
          key: 'nvdm',
          target: {
            type: documentsTypes.file,
            item: '2020/nvdm.pdf'
          },
          description: `SPIADI 2020 - Premiers résultats de la surveillance nationale SPIADI 2020.pdf`
        },
        {
          texts: [`De l'hémoculture positive à la bactériémie liée au catheter`],
          subtexts: [
            `Dr Anne-Sophie VALENTIN, SPIADI, CPias Centre val de Loire,
CHU Tours`
          ],
          type: 'alt',
          src: '2020/valentin.jpg',
          key: 'valentin',
          target: {
            type: documentsTypes.file,
            item: '2020/valentin.pdf'
          },
          description: `SPIADI 2020 - Dr VALENTIN - De l'hémoculture positive à la bactériémie liée au catheter.pdf`
        },
        {
          texts: [`Pneumonie acquise sous ventilation mécanique`],
          subtexts: [
            `Pr Jean-Ralph ZAHAR, Unité de Prévention du Risque Infectieux,
GH Paris Seine Saint-Denis`
          ],
          type: 'std',
          src: '2020/zahar.jpg',
          key: 'zahar',
          target: {
            type: documentsTypes.file,
            item: '2020/zahar.pdf'
          },
          description: `SPIADI 2020 - Pr ZAHAR - Pneumonie acquise sous ventilation mécanique.pdf`
        },
        {
          texts: [`Surveillance des pneumopathies : premiers résultats 2020`],
          subtexts: [
            `Dr Nathalie VAN DER MEE-MARQUET, SPIADI, CPias Centre val de Loire,
CHU Tours`
          ],
          type: 'alt',
          src: '2020/pneu.jpg',
          key: 'pneu',
          target: {
            type: documentsTypes.file,
            item: '2020/pneumopathies.pdf'
          },
          description: `SPIADI 2020 - Surveillance des pneumopathies : premiers résultats 2020.pdf`
        },
        {
          texts: [`Résultats de l'étude RÉA Sink 2020`],
          subtexts: [
            `Dr Nathalie VAN DER MEE-MARQUET, SPIADI, CPias Centre val de Loire,
CHU Tours`
          ],
          type: 'std',
          src: '2020/reasink.jpg',
          key: 'reasink',
          target: {
            type: documentsTypes.file,
            item: '2020/rea sink.pdf'
          },
          description: `SPIADI 2020 - Résultats de l'étude Réa Sink 2020.pdf`
        },
        {
          texts: [`Observation des pratiques : résultats 2020`],
          subtexts: [
            `Agnès PETITEAU et Sylvie BAUNE, CPias Centre val de Loire, CHU Tours`
          ],
          type: 'std',
          src: '2020/observa4.jpg',
          key: 'obs4',
          target: {
            type: documentsTypes.file,
            item: '2020/observa4.pdf'
          },
          description: `SPIADI 2020 - Observation des pratiques : résultats 2020.pdf`
        },
        {
          texts: [`Audit régional de pertinence de maintien des CVP`],
          subtexts: [
            `Dr Cécile MOURLAN, CPias Occitanie, CHU Montpellier`
          ],
          type: 'alt',
          src: '2020/mourlan.jpg',
          key: 'mourlan',
          target: {
            type: documentsTypes.file,
            item: '2020/mourlan.pdf'
          },
          description: `SPIADI 2020 - Audit régional de pertinence de maintien des CVP.pdf`
        }
      ],
      communications: [
        {
          key: 'lily',
          type: 'alt',
          src: 'missionday/2020/lily.jpg',
          target: {
            type: documentsTypes.link,
            item: 'https://www.spiadi.fr/tools?tab=1'
          },
          hover: `Accéder à l'outil`,
          texts: [
            `Outil pédagogique pour la prévention des infections liées aux CVPs`
          ],
          subtexts: [
            `Mathilde FARIZON, Agnès PETITEAU et le groupe de travail régional
en région Centre val de Loire`
          ]
        },
        {
          key: 'walocha',
          type: 'std',
          texts: [
            `Former par la simulation à la prévention des infections liées aux
dispositifs intra-vasculaires`
          ],
          subtexts: [
            `Valérie WALOCHA, Nadia BOUAMRIA, Isabelle TRONCHON, CHU Lille`
          ]
        },
        {
          key: 'pichon',
          type: 'alt',
          texts: [
            `Supériorité de la Chlorhexidine alcoolique à 2% et de dispositifs
innovants en prévention des complications de l’utilisation des CVPs`
          ],
          subtexts: [
            `Maxime PICHON, CHU Poitiers`
          ]
        }
      ]
    },
    {
      key: 'c2019',
      year: '2019',
      slides: [
        slide('2019', '02'),
        slide('2019', '03'),
        slide('2019', '04'),
        slide('2019', '10'),
        slide('2019', '12'),
        slide('2019', '13'),
        slide('2019', '14'),
        slide('2019', '05'),
        slide('2019', '06'),
        slide('2019', '07')
      ],
      speeches: [
        {
          texts: [`Résultats de la surveillance nationale SPIADI 2019`],
          subtexts: [
            `Dr Nathalie VAN DER MEE-MARQUET, SPIADI, CPias Centre val de Loire,
CHU Tours`
          ],
          type: 'alt',
          src: '2019/nathalie_vandermee.jpg',
          key: 'nvdm',
          target: {
            type: documentsTypes.file,
            item: '2019/nvdm.pdf'
          },
          description: `SPIADI 2019 - Résultats de la surveillance nationale SPIADI 2019.pdf`
        },
        {
          texts: [`Coût et évitabilité des infections associées aux cathéters : les
enjeux de la prévention`],
          subtexts: [
            `Dr Walter ZINGG, Service de Prévention et Contrôle de l’Infection,
Hôpitaux Universitaires de Genève, Genève`
          ],
          type: 'std',
          src: `2019/walter_zingg.jpeg`,
          key: 'zingg',
          target: {
            type: documentsTypes.file,
            item: `2019/zingg.pdf`
          },
          description: `SPIADI2019 - Dr ZINGG - Coût et évitabilité des infections associées aux cathéters - les enjeux de la prévention.pdf`
        },
        {
          texts: [
            `Les recommandations aujourd’hui pour la prévention des infections
associées aux cathéters`
          ],
          subtexts: ['Pr Didier LEPELLETIER, CHU Nantes'],
          type: 'alt',
          src: '2019/didier_lepelletier.jpeg',
          key: 'reco',
          target: {
            type: documentsTypes.file,
            item: `2019/lepelletier.pdf`
          },
          description: `SPIADI2019 - Pr LEPELLETIER - Les recommandations aujourd’hui pour la prévention des infections associées aux cathéters.pdf`
        },
        {
          texts: ['Les bonnes pratiques pour la réalisation de l’hémoculture'],
          subtexts: ['Dr Brigitte LAMY, CHRU Nice'],
          type: 'std',
          src: '2019/brigitte_lamy.jpeg',
          key: 'goodpractice',
          target: {
            type: documentsTypes.file,
            item: '2019/lamy.pdf'
          },
          description: `SPIADI2019 - Dr LAMY - Les bonnes pratiques pour la réalisation de l'hémoculture.pdf`
        },
        {
          texts: ['Les MIDlines et PICClines, en pratique'],
          subtexts: ['Christian DUPONT, AP-HP, Paris'],
          type: 'alt',
          key: 'midpicc',
          src: '2019/christian_dupont.jpeg',
          target: {
            type: documentsTypes.file,
            item: '2019/dupont.pdf'
          },
          description: `SPIADI2019 - Mr DUPONT - Les MIDlines et PICClines, en pratique.pdf`
        }
      ],
      communications: [
        {
          texts: [
            `Surveillance de la survenue de complications infectieuses chez les
patients porteurs de PICC-Line`
          ],
          subtexts: ['Dr Nathalie PESTOURIE, CHU Limoges'],
          type: 'std',
          key: 'pestourie'
        },
        {
          texts: [
            `Analyse des causes profondes d’une infection sur cathéter veineux
central en SSR`
          ],
          subtexts: ['Marie FREMONT, CMP Varennes-Jarcy'],
          type: 'alt',
          key: 'fremont'
        },
        {
          texts: [
            `Abords vasculaires périphériques : bonnes et mauvaises pratiques`
          ],
          subtexts: ['Dr Olivier CAPEYRON, CH Cannes'],
          type: 'std',
          key: 'capeyron'
        },
        {
          texts: [
            `Alerte sur les bactériémies sur voies veineuses périphériques –
Investigation et programme d’action`
          ],
          subtexts: [`Dr Séverine GALLAIS-HOFF, CH St Nazaire`],
          type: 'alt',
          key: 'gallais'
        },
        {
          texts: [
            `Evaluation du risque infectieux lors d’une séance de dialyse sur
cathéter central`
          ],
          subtexts: ['Mélanie DOYELLE, Santélys, Loos'],
          type: 'std',
          key: 'doyelle'
        },
        {
          texts: [
            `Démarche de gestion du risque infectieux : les abords vasculaires
de type Buttonhole, en hémodialyse`
          ],
          subtexts: ['Françoise DE MONTI, Mary LE VERN, AUB Santé, St Malo'],
          type: 'alt',
          key: 'demonti'
        },
        {
          texts: [
            `Amélioration des pratiques de pose et de maintien des CVP chez les
patients admis dans un service d’accueil des Urgences`
          ],
          subtexts: ['Blandine GUILLEY-LERONDEAU, CHU Nantes'],
          type: 'std',
          key: 'guilley'
        },
        {
          texts: [
            `Thrombose associée à une infection de pose sur CCI en oncologie :
observance des recommandations`
          ],
          subtexts: ['Dr Dominique VANJAK, Institut Curie, Paris'],
          type: 'alt',
          key: 'vanjak'
        },
        {
          texts: [
            `Prévention des infections de cathéters : rinçage pulsé, une vidéo
explicative pour les soignants`
          ],
          subtexts: [
            'Marie-Gabrielle DEMANGE, CHMS Chambéry'
          ],
          type: 'alt',
          key: 'demange'
        }
      ]
    }
  ]
}
